export const diagnoses = {
  assessment: {
    heading: 'Select Chronic Diagnosis',
    searchLabel: 'Search Chronic Diagnoses',
    searchPlaceholder: 'Type to search...',
    searchHelper: 'Select a chronic diagnosis to review',
    codeCaption: (code: string) => `Code: ${code}`,
    categoryCaption: (category: string) => `Category: ${category}`,
    icdChip: 'ICD-10',
    alreadyAddedChip: 'Already added',
    alreadyAddedSnackbar: "This diagnosis is already on the patient's list",
    snomedChip: 'SNOMED',
    confirmationHeading: 'Diagnosis Assessment Confirmation',
    confirmationIntro: 'This action will add a new diagnosis,',
    confirmationFor: 'for',
    confirmationInPortal: 'in the Truentity Portal.',
    basedOnDocument:
      "The diagnosis has been reviewed and assessed based on a clinical document uploaded to and associated with this patient's record.",
    basedOnAssessment: "The diagnosis has been assessed by the provider and is being added ahead of the patient's synced clinical data.",
    ensureAccurate: 'Please ensure this assessment is accurate and appropriately supported before proceeding.',
    ensureAccurateWithDocument:
      'Please ensure this assessment is accurate and appropriately supported by the reviewed documentation before proceeding.',
    ccmNotice:
      "The diagnosis will be added to the patient's diagnoses list. It becomes a CCM Condition only once it is selected in the Clinical Diagnoses section.",
    nameLabel: 'Diagnosis Name:',
    codeLabel: 'Code:',
    categoryLabel: 'Category:',
    systemLabel: 'System:',
    otherCategory: 'Other',
    chronicChip: 'Chronic Condition',
    systems: {
      icd: 'ICD-10',
      snomed: 'SNOMED CT',
      other: 'Other'
    },
    selectFirst: 'Please select a diagnosis first',
    addedSnackbar: 'Diagnosis added to patient successfully',
    addFailedSnackbar: 'Failed to add diagnosis to patient. Please try again.'
  },
  addDialog: {
    buttonLabel: 'Add Diagnoses',
    buttonTooltip: 'Add a diagnosis to this patient',
    title: (patientName: string) => (patientName ? `Add Diagnoses - ${patientName}` : 'Add Diagnoses'),
    cancel: 'Cancel',
    finish: 'Finish'
  }
} as const;
